import { render, staticRenderFns } from "./generateMerchantPaymentComponent.vue?vue&type=template&id=5f01aace&"
import script from "./generateMerchantPaymentComponent.vue?vue&type=script&lang=js&"
export * from "./generateMerchantPaymentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports